import React from 'react'
import { router, usePage, useForm } from '@inertiajs/react'
import {
  Box, Button, TextField, Select, MenuItem, FormControl, InputLabel,
  Paper, Typography, Grid,
} from '@mui/material'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'

Form.layout = (page) => <AppShell>{page}</AppShell>

export default function Form({ property, assembly, action, errors: serverErrors = {} }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const isEdit = action === 'edit'

  const { data, setData, post, put, processing, errors } = useForm({
    assembly_type: assembly.assembly_type || 'regular',
    date: assembly.date || '',
    time: assembly.time || '',
    location: assembly.location || '',
    chairperson: assembly.chairperson || '',
    minutes_taker: assembly.minutes_taker || '',
    manager: assembly.manager || '',
  })

  const allErrors = { ...serverErrors, ...errors }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (isEdit) {
      put(`/m/${tenant.slug}/properties/${property.id}/assemblies/${assembly.id}`)
    } else {
      post(`/m/${tenant.slug}/properties/${property.id}/assemblies`)
    }
  }

  return (
    <Box>
      <PageHeader
        title={isEdit ? 'Versammlung bearbeiten' : 'Neue Versammlung'}
        breadcrumbs={[
          { label: 'Versammlungen', href: `/m/${tenant.slug}/properties/${property.id}/assemblies` },
          { label: isEdit ? 'Bearbeiten' : 'Neue Versammlung' },
        ]}
      />

      <Paper elevation={0} sx={{ p: 3, border: '1px solid', borderColor: 'divider', maxWidth: 600 }}>
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth size="small" required error={!!allErrors.assembly_type}>
                <InputLabel>Typ</InputLabel>
                <Select value={data.assembly_type} label="Typ"
                  onChange={(e) => setData('assembly_type', e.target.value)}
                  data-testid="assembly-type-select">
                  <MenuItem value="regular">Ordentlich</MenuItem>
                  <MenuItem value="extraordinary">Außerordentlich</MenuItem>
                  <MenuItem value="circular_resolution">Umlaufbeschluss</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField label="Datum" type="date" required fullWidth size="small"
                value={data.date} onChange={(e) => setData('date', e.target.value)}
                error={!!allErrors.date} helperText={allErrors.date?.[0]}
                slotProps={{ inputLabel: { shrink: true }, htmlInput: { 'data-testid': 'date-input' } }} />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField label="Uhrzeit" type="time" fullWidth size="small"
                value={data.time} onChange={(e) => setData('time', e.target.value)}
                slotProps={{ inputLabel: { shrink: true } }} />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField label="Ort" fullWidth size="small"
                value={data.location} onChange={(e) => setData('location', e.target.value)}
                slotProps={{ htmlInput: { 'data-testid': 'location-input' } }} />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField label="Versammlungsleiter" fullWidth size="small"
                value={data.chairperson} onChange={(e) => setData('chairperson', e.target.value)} />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField label="Protokollführer" fullWidth size="small"
                value={data.minutes_taker} onChange={(e) => setData('minutes_taker', e.target.value)} />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField label="Verwalter" fullWidth size="small"
                value={data.manager} onChange={(e) => setData('manager', e.target.value)} />
            </Grid>
          </Grid>

          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button type="submit" variant="contained" disabled={processing} data-testid="submit-btn">
              {processing ? 'Wird gespeichert...' : 'Speichern'}
            </Button>
            <Button variant="outlined"
              onClick={() => router.visit(`/m/${tenant.slug}/properties/${property.id}/assemblies`)}>
              Abbrechen
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}
